module.exports = __webpack_public_path__ + "media/images/games/fifa-21/background-28ab607dbf86e82d99bc821676ea33e8.jpg";